import { RxStompConfig, Versions } from "@stomp/rx-stomp";
import { RxStompService } from "@app/services/webstomp/rx-stomp.service";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { MSALInstanceFactory } from "./auth-factories";
import { MsalService } from "@azure/msal-angular";

/**
 * Factory function to create WebSocket configuration for the Scheduler service
 */
export function SchedulerStompConfigFactory(
  clientConfigService: ClientConfigService
): RxStompConfig {
  return {
    beforeConnect(client: RxStompService): Promise<void> {
      return new Promise<void>((resolve, reject) => {
        setTimeout(() => {
          const matches =
            clientConfigService.config.azureConfig.apiConfig.filter((x) =>
              clientConfigService.config.messageUrl.startsWith(x.origin)
            );
          if (matches.length === 0) {
            reject("Unable to find token scope");
          }
          try {
            const msalInstance = MSALInstanceFactory(clientConfigService);
            msalInstance.initialize().then((value) => {
              const accounts = msalInstance.getAllAccounts();

              // Check if we have any accounts before trying to get a token
              if (accounts.length === 0) {
                console.log(
                  "[WebSocket] No authenticated accounts found, delaying websocket connection"
                );
                // Reject with a specific message that this isn't a critical error
                reject({
                  ignorable: true,
                  message: "No authenticated accounts available"
                });
                return;
              }

              console.log(
                "[WebSocket] Attempting to acquire token for websocket connection"
              );
              msalInstance
                .acquireTokenSilent({
                  scopes: matches[0].scopes,
                  account: accounts[0]
                })
                .then((token) => {
                  console.log(
                    "[WebSocket] Token acquired successfully, configuring websocket"
                  );
                  client.configure({
                    brokerURL: clientConfigService.config.messageUrl,
                    connectHeaders: {
                      login: "azure",
                      passcode: token.accessToken
                    },
                    logRawCommunication: true,
                    stompVersions: new Versions(["1.3", "1.2", "1.1"]),
                    heartbeatIncoming: 10000,
                    heartbeatOutgoing: 10000,
                    connectionTimeout: 5000,

                    reconnectDelay: 5000,
                    debug: (msg: string): void => {
                      // console.log(msg);
                    },

                    discardWebsocketOnCommFailure: false
                  });
                  resolve();
                })
                .catch((error) => {
                  console.log(
                    "[WebSocket] Error acquiring token for websocket:",
                    error
                  );
                  reject(error);
                });
            });
          } catch (e) {
            console.warn("Cannot create websocket due to ", e);
            reject(e);
          }
        }, 1000);
      });
    }
  };
}

/**
 * Factory function to create the RxStomp service instance
 */
export function rxStompServiceFactory(myRxStompConfig: RxStompConfig) {
  const rxStomp = new RxStompService();
  rxStomp.configure(myRxStompConfig);
  rxStomp.activate();
  return rxStomp;
}
